import { render, staticRenderFns } from "./PasswordSetupPrompt.vue?vue&type=template&id=995ef62e&"
import script from "./PasswordSetupPrompt.vue?vue&type=script&lang=js&"
export * from "./PasswordSetupPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports